var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"cartorio","rota-base":"/admin/cartorio","titulo":"CARTÓRIOS","titulo-singular":"Cartório","colunas-extras":[
        { campo: "serventia", label: "Serventia", tipo: "string" }
    ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }